import moment from 'moment';
class salary {
    constructor(
        Liquidacion,
        Empleado,
        Legajo,
        Fecha,
        Concepto_de_Sueldo,
        Centro_de_Costo,
        Unidad,
        Cantidad 
    ) {

        this.Liquidacion = Liquidacion;
        this.Empleado = Empleado
        this.Legajo = Legajo
        this.Fecha = moment(Fecha).utc().format("DD-MM-YYYY")
        this.Concepto_de_Sueldo = Concepto_de_Sueldo
        this.Centro_de_Costo = Centro_de_Costo
        this.Unidad = Unidad
        this.Cantidad = Cantidad

    }
    static fromJson({
        Liquidacion,
        Empleado,
        Legajo,
        Fecha,
        Concepto_de_Sueldo,
        Centro_de_Costo,
        Unidad,
        Cantidad
    }) {
        return new salary(
            Liquidacion,
            Empleado,
            Legajo,
            Fecha,
            Concepto_de_Sueldo,
            Centro_de_Costo,
            Unidad,
            Cantidad
        );
    }
}
export default salary;
